import { Component, Input, ChangeDetectionStrategy, TemplateRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from '../../../@core/data/general.service';

export interface ModalDialogButton {
  label: string;
  style: 'primary' | 'outline';
  action: 'confirm' | 'dismiss';
}

export interface ModalDialogHeaderAction {
  label: string;
  style: 'primary' | 'outline';
  loading?: boolean;
  callback: () => void;
}

@Component({
  selector: 'edm-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ModalDialogComponent {

  /** Mode: 'default' for simple dialogs, 'content' for custom body */
  @Input() mode: 'default' | 'content' = 'default';

  /** Default mode inputs */
  @Input() icon: string = '';
  @Input() image: string = '';
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() buttons: ModalDialogButton[] = [];

  /** Content mode inputs */
  @Input() headerActions: ModalDialogHeaderAction[] = [];
  @Input() contentTemplate: TemplateRef<unknown>;
  @Input() closeCallback: (() => void) | undefined;

  closeLabel: string;

  constructor(
    public activeModal: NgbActiveModal,
    private generalService: GeneralService,
  ) {
    this.closeLabel = this.generalService.getTranslate('timeline.modules.closeLabel');
  }

  onButton(button: ModalDialogButton): void {
    if (button.action === 'confirm') {
      this.activeModal.close(true);
    } else {
      this.activeModal.dismiss();
    }
  }

  onHeaderAction(action: ModalDialogHeaderAction): void {
    action.callback();
  }

  close(): void {
    if (this.closeCallback) {
      this.closeCallback();
    } else {
      this.activeModal.dismiss();
    }
  }
}
